import React, { useCallback } from 'react';
import { Form, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { DeleteButton, Button } from '@rd-web-markets/shared/dist/util/buttons';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import ElsterFileSection from './ElsterFileSection';
import generalService from '@rd-web-markets/shared/dist/services/claim_groups/general_service';
import { DatePicker, dateToString } from '@rd-web-markets/shared/dist/util/date';
import lastIndex from '@rd-web-markets/shared/dist/util/helpers/lastIndex';
import { generateElsterDocument } from '../../../services/elster_docx/elster_docx_.service';
import elsterDataService from '@rd-web-markets/market/dist/services/elster_docx/elster_data.service';
import { useSelector } from 'react-redux';
const ElsterUploadSection = _ref => {
  let {
    elster,
    setElster
  } = _ref;
  const {
    t
  } = useTranslation();
  const [getElsterData] = elsterDataService.useCrud(elster.id);
  const user = useSelector(state => state.auth.user);
  const deleteFile = useErrorHandling(useCallback(async (elsterId, fileId, elster) => {
    const currentElster = elster.elster_actions.find(elster => elster.id === elsterId);
    await generalService.delete(elsterId, 'elster_actions', 'elster_action_attachments', fileId);
    delete currentElster.file;
    setElster({
      ...elster
    });
  }, [setElster]));
  const changeDate = useErrorHandling(useCallback(async (elsterId, date, elster) => {
    const currentElster = elster.elster_actions.find(elster => elster.id === elsterId);
    const body = {
      elster_action: {
        document_date: date
      }
    };
    const response = await generalService.update(elster.id, 'elsters', 'elster_actions', body, elsterId);
    currentElster.document_date = response.document_date;
    setElster({
      ...elster
    });
  }, [setElster]));
  const updateInvoicePaid = useErrorHandling(useCallback(async (elsterId, elster, e) => {
    const currentElster = elster.elster_actions.find(elster => elster.id === elsterId);
    const body = {
      elster_action: {
        invoice_paid: e.target.checked
      }
    };
    const response = await generalService.update(elster.id, 'elsters', 'elster_actions', body, elsterId);
    currentElster.invoice_paid = response.invoice_paid;
    setElster({
      ...elster
    });
  }, [setElster]));
  const renderDatePicker = elster_action => {
    return /*#__PURE__*/React.createElement(DatePicker, {
      onChange: date => changeDate(elster_action.id, date, elster),
      selected: elster_action.document_date
    });
  };
  const createElster = useErrorHandling(useCallback(async () => {
    const elsterData = await getElsterData();
    generateElsterDocument({
      data: elsterData,
      user
    });
  }, [getElsterData, user]));
  const getElsterPdfDate = elsterPdfDate => {
    if (elsterPdfDate) {
      return dateToString(new Date(elsterPdfDate));
    }
  };
  const tableActions = elster.elster_actions.map((elster_action, index) => {
    const isElsterFormCreatedRow = elster_action.action_name == 'elster_form_created';
    const documentDate = isElsterFormCreatedRow ? getElsterPdfDate(elster.elster_pdf_file?.created_at) : renderDatePicker(elster_action);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
      key: 'project_actions' + elster_action.action_name
    }, /*#__PURE__*/React.createElement("td", null, t(elster_action.action_name)), /*#__PURE__*/React.createElement("td", null, documentDate), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ElsterFileSection, {
      elsterId: elster_action.id,
      elster: elster,
      setElster: setElster
    })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
      href: elster_action.file?.url,
      target: "_blank",
      rel: "noreferrer"
    }, elster_action.file?.filename)), /*#__PURE__*/React.createElement("td", null, elster_action.file?.filename && /*#__PURE__*/React.createElement(DeleteButton, {
      style: {
        marginRight: '8px'
      },
      onClick: () => deleteFile(elster_action.id, elster_action.file?.id, elster),
      "data-testid": "delete_button"
    })), /*#__PURE__*/React.createElement("td", null, isElsterFormCreatedRow && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      onClick: () => {
        createElster(elster);
      },
      className: "ms-auto me-3"
    }, t('create_elster'))))), lastIndex(elster.elster_actions) === index && /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, t('invoice_paid')), /*#__PURE__*/React.createElement("td", null, elster_action.invoice_paid, /*#__PURE__*/React.createElement(Form.Check, {
      type: "checkbox",
      name: "invoice_paid",
      checked: elster_action.invoice_paid,
      value: elster_action.invoice_paid,
      onChange: e => updateInvoicePaid(elster_action.id, elster, e)
    })), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null)));
  });
  if (!elster.elster_actions.length) return /*#__PURE__*/React.createElement("p", {
    className: "ms-4 text-danger"
  }, "please contact admin to add elsters to this section");
  return /*#__PURE__*/React.createElement(Table, {
    size: "sm",
    style: {
      marginLeft: '20px'
    }
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, t('action')), /*#__PURE__*/React.createElement("th", null, t('date')), /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", null)), tableActions));
};
export default ElsterUploadSection;